export default {
      id: "ic_facebook-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_facebook-usage",
      toString: function () {
        return this.url;
      }
    }